import React            from 'react';
import { connect }      from 'react-redux';
import CSSModules       from 'react-css-modules';

import Button           from '../Button';
import FontIcon         from '../FontIcon';
import Overlay          from '../Overlay';
import InputGroup       from '../InputGroup';
import Label            from '../Label';
import SelectBox        from '../SelectBox';
import CourseForm       from '../CourseForm';
import TestimonialForm  from '../TestimonialForm';
import YesNoOptionPanel from '../YesNoOptionPanel';
import TestimonialList  from "../TestimonialList";

import * as courseList  from '../../actions/courseList';

import style            from './style.scss';

class CourseList extends React.Component {

    componentDidMount() {

        this.props.loadCourses();
        this.props.loadModules();
        this.props.loadTimetables();
        this.props.loadVenues();
        this.props.loadPresenters();
        this.props.loadResourcePacks();
    }

    _getCourseOverlayTitle() {

        const courseTitle = this.props.isELearningCourse ? 'ELearning Course' : 'Course';

        switch (this.props.courseFormMode) {

            case 'add':
                return 'Add ' + courseTitle;

            case 'edit':
                return 'Edit ' + courseTitle;
        }
    }

    _getTestimonialOverlayTitle() {

        switch (this.props.testimonialFormMode) {

            case 'add':
                return 'Add Testimonial';

            case 'edit':
                return 'Edit Testimonial';
        }
    }

    _getTestimonialForm() {

        if (this.props.isAddTestimonialOverlayOpen || this.props.isEditTestimonialOverlayOpen) {

            return <TestimonialForm
                mode={ this.props.testimonialFormMode }
                loadCourses={this.props.loadCourses}
            />
        }
    }

    _getDeleteCourseOverlayContent() {

        if (this.props.isDeleteCourseOverlayOpen) {

            const { courseToDelete } = this.props;

            return (
                <div>

                    <p>
                        Are you sure you want to to delete the&nbsp;

                        <span styleName="course-name--to-delete">
                            { courseToDelete.name }
                        </span>

                        &nbsp;course and all of its associated events and testimonials?
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeleteCourseOverlay }
                                      yes={ this.props.deleteCourse.bind(this, courseToDelete.id) } />

                </div>
            );
        }
    }

    _getDeleteTestimonialOverlayContent() {

        if (this.props.isDeleteTestimonialOverlayOpen) {

            const { selectedCourseId, testimonialToDelete } = this.props;

            const deleteTestimonial = this.props.deleteTestimonial.bind(this, selectedCourseId, testimonialToDelete.id);

            return (
                <div>

                    <p>
                        Are you sure you want to to delete the testimonial created by&nbsp;

                        <span styleName="course-name--to-delete">
                            { testimonialToDelete.author_name }?
                        </span>
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeleteTestimonialOverlay }
                                      yes={ deleteTestimonial } />

                </div>
            );
        }
    }

    render() {

        return (

            <article>

                <Button onClick={ this.props.showNewCourseOverlay.bind(this, false) }
                        className={ style['new-course-button'] }>

                    <FontIcon textPosition="right" iconName="plus" />
                    <span>New course</span>

                </Button>

                <Overlay isOpen={ this.props.isDeleteCourseOverlayOpen }
                         closeOverlay={ this.props.hideDeleteCourseOverlay }
                         title="Delete Course"
                         size="small">

                    { this._getDeleteCourseOverlayContent() }

                </Overlay>

                <Overlay isOpen={ this.props.isTestimonialListOverlayOpen }
                         closeOverlay={ this.props.closeTestimonialListOverlay }
                         title="Testimonials"
                         size="medium">

                    <TestimonialList
                        showAddTestimonialForm={this.props.showAddTestimonialForm}
                        testimonials={this.props.testimonials}
                        courses={this.props.courses}
                        selectedCourseId={this.props.selectedCourseId}
                        loadCourses={this.props.loadCourses}
                        showEditTestimonialForm={this.props.showEditTestimonialForm}
                        showDeleteTestimonialOverlay={this.props.showDeleteTestimonialOverlay}
                    />

                </Overlay>

                <Overlay isOpen={ this.props.isAddTestimonialOverlayOpen || this.props.isEditTestimonialOverlayOpen }
                         closeOverlay={ this.props.closeTestimonialFormOverlay }
                         cancelOverlay={ this.props.cancelTestimonialFormOverlay }
                         title={ this._getTestimonialOverlayTitle() }
                         size="medium">

                    { this._getTestimonialForm() }

                </Overlay>

                <Overlay isOpen={ this.props.isDeleteTestimonialOverlayOpen }
                         closeOverlay={ this.props.hideDeleteTestimonialOverlay }
                         title="Delete Testimonial"
                         size="small">

                    { this._getDeleteTestimonialOverlayContent() }

                </Overlay>

                <Overlay isOpen={ this.props.isCourseOverlayOpen }
                         closeOverlay={ this.props.hideCourseOverlay }
                         title={ this._getCourseOverlayTitle() }
                         size="medium">

                    <CourseForm timetables={ this.props.timetables }
                                presenters={ this.props.presenters }
                                resourcePacks={ this.props.resourcePacks }
                                venues={ this.props.venues }
                                modules={ this.props.modules }
                                mode={ this.props.courseFormMode }
                                eLearningCourses={ this.props.eLearningCourses }
                                isELearningCourse={ this.props.isELearningCourse }
                                onRefreshCoursesClick={ this.props.loadCourses }
                    />

                </Overlay>

                <InputGroup>
                    <Label>Filter by category</Label>

                    <SelectBox onChange={ this.props.filterCourses } className={ style['module-filter'] }>

                        <option value="0">All</option>

                        {
                            this.props.modules.map((module) => {

                                return (
                                    <option key={ module.id } value={ module.id }>
                                        { module.name }
                                    </option>
                                )
                            })
                        }

                    </SelectBox>

                </InputGroup>

                <section styleName="course-list">

                    {
                        this.props.courses.map((course) => {

                            return (
                                <article key={ course.id } styleName="course">

                                    <header styleName="course-header">

                                        <h2 styleName="course-name">
                                            { course.name }
                                            { course.elearning_course_id ? ' (E-Learning)' : '' }
                                        </h2>

                                        <h3 styleName="course-module">
                                            { course.module.name }
                                        </h3>

                                    </header>

                                    <div styleName="course-action-panel">
                                        
                                        <span styleName="course-action"
                                              onClick={ this.props.showEditCourseOverlay.bind(this, course, course.elearning_course_id) }>
                                            Edit
                                        </span>
                                        
                                        <span styleName="course-action"
                                              onClick={ this.props.showDeleteCourseOverlay.bind(this, course) }>
                                            Delete
                                        </span>
                                        
                                    </div>

                                    <Button onClick={ this.props.openTestimonialListOverlay.bind(this, course.id) }
                                            type="secondary"
                                            autoWidth="true">

                                        <span>Testimonials</span>

                                        <FontIcon className={ style['testimonial-count-icon'] } textPosition="left" iconName="circle">
                                            <span styleName="testimonial-count">{ course.testimonials_count }</span>
                                        </FontIcon>

                                    </Button>

                                </article>
                            )
                        })
                    }
                    
                </section>

            </article>
        );
    }
}

function mapStateToProps(state) {

    return state.courseList;
}

function mapDispatchToProps(dispatch) {

    return {
        loadPresenters() {

            dispatch(courseList.loadPresenters());
        },
        loadResourcePacks() {

            dispatch(courseList.loadResourcePacks());
        },
        loadVenues() {

            dispatch(courseList.loadVenues());
        },
        loadTimetables() {

            dispatch(courseList.loadTimetables());
        },
        cancelTestimonialFormOverlay: () => {

            dispatch(courseList.cancelTestimonialFormOverlay());
        },
        closeTestimonialFormOverlay: () => {

            dispatch(courseList.closeTestimonialFormOverlay());
        },
        deleteTestimonial: (courseId, testimonialId) => {

            dispatch(courseList.deleteTestimonial(courseId, testimonialId));
        },
        showEditTestimonialForm: (testimonial) => {

            dispatch(courseList.showEditTestimonialForm(testimonial));
        },
        showDeleteTestimonialOverlay: (testimonial) => {

            dispatch(courseList.showDeleteTestimonialOverlay(testimonial));
        },
        hideDeleteTestimonialOverlay: () => {

            dispatch(courseList.hideDeleteTestimonialOverlay());
        },
        deleteCourse: (courseId) => {

            dispatch(courseList.deleteCourse(courseId));
        },
        hideDeleteCourseOverlay: () => {

            dispatch(courseList.hideDeleteCourseOverlay());
        },
        showDeleteCourseOverlay: (course) => {

            dispatch(courseList.showDeleteCourseOverlay(course));
        },
        showEditCourseOverlay: (course, isELearningCourse) => {

            dispatch(courseList.showEditCourseOverlay(course));
            dispatch(courseList.setIsELearningCourse(isELearningCourse));
        },
        loadModules: () => {

            dispatch(courseList.refreshModules());
        },
        loadCourses: () => {

            return dispatch(courseList.refreshCourses());
        },
        showNewCourseOverlay: (isELearningCourse) => {

            dispatch(courseList.showNewCourseOverlay());
            dispatch(courseList.setIsELearningCourse(isELearningCourse));
        },
        hideCourseOverlay: (IsLearningCourse) => {

            dispatch(courseList.hideCourseOverlay());
            dispatch(courseList.setIsELearningCourse(IsLearningCourse));
        },
        closeTestimonialListOverlay: () => {

            dispatch(courseList.hideTestimonialListOverlay());
        },
        openTestimonialListOverlay: (courseId) => {
            
            dispatch(courseList.showTestimonialListOverlay(courseId));
            dispatch(courseList.loadSelectedTestimonials(courseId));
        },

        showAddTestimonialForm: (courseId) => {

            dispatch(courseList.showAddTestimonialForm(courseId));
        },
        filterCourses: (event) => {

            if (event.target.value !== '0') {

                dispatch(courseList.filterCoursesByModule(event.target.value));

            } else {

                dispatch(courseList.refreshCourses());
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(CourseList, style));


// WEBPACK FOOTER //
// ./components/CourseList/index.js